import script from "./MoleculeModalAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeModalAlert.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeModalAlert.vue?vue&type=style&index=0&id=4d3c1893&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3c1893"]])

export default __exports__